// M13: 圓的性質 - Properties of Circles
// 系統化數據結構，準備 Supabase 後端遷移

export const M13_MODULE_INFO = {
  moduleId: 'M13',
  title: '圓的性質',
  titleEn: 'Properties of Circles',
  description: '學習圓的幾何性質和定理',
  totalTopics: 7,
  estimatedTime: '8-10小時',
  difficulty: 'intermediate',
  prerequisites: ['M04', 'M06'],
  learningObjectives: [
    '掌握圓的基本性質',
    '理解弦的性質定理',
    '應用切線的性質',
    '運用圓周角定理',
    '解決圓的幾何問題'
  ]
};

export const M13_TOPICS = [
  {
    id: 'M13_01',
    name: "圓的基本性質",
    description: "圓的基本概念和性質",
    order: 1,
    subTopics: [
      "圓的定義和要素",
      "圓心角和圓周角",
      "弧長和扇形面積",
      "圓的對稱性質",
      "圓的基本定理"
    ]
  },
  {
    id: 'M13_02',
    name: "弦的性質",
    description: "圓中弦的相關性質和定理",
    order: 2,
    subTopics: [
      "弦的定義和性質",
      "垂直平分弦的性質",
      "等弦的性質",
      "弦與圓心距的關係",
      "弦的相交性質"
    ]
  },
  {
    id: 'M13_03',
    name: "切線的性質",
    description: "圓的切線性質和應用",
    order: 3,
    subTopics: [
      "切線的定義和性質",
      "切線的判定定理",
      "切線長定理",
      "切線的作圖",
      "切線的應用問題"
    ]
  },
  {
    id: 'M13_04',
    name: "圓周角定理",
    description: "圓周角的性質和應用",
    order: 4,
    subTopics: [
      "圓周角的定義",
      "圓周角定理",
      "同弧圓周角的性質",
      "圓內接四邊形",
      "圓周角的應用"
    ]
  },
  {
    id: 'M13_05',
    name: "相交弦定理",
    description: "圓內外弦的相交性質",
    order: 5,
    subTopics: [
      "圓內相交弦定理",
      "圓外相交弦定理",
      "切割線定理",
      "相交弦的應用",
      "功率定理"
    ]
  },
  {
    id: 'M13_06',
    name: "圓的位置關係",
    description: "點、直線與圓的位置關係",
    order: 6,
    subTopics: [
      "點與圓的位置關係",
      "直線與圓的位置關係",
      "圓與圓的位置關係",
      "公切線的性質",
      "相切圓的性質"
    ]
  },
  {
    id: 'M13_07',
    name: "圓的綜合應用",
    description: "圓的性質在幾何問題中的應用",
    order: 7,
    subTopics: [
      "圓的作圖問題",
      "圓的計算問題",
      "圓的證明問題",
      "圓與其他圖形",
      "實際應用問題"
    ]
  }
];

// 導出模組統計信息
export const M13_STATS = {
  totalTopics: M13_TOPICS.length,
  totalSubTopics: M13_TOPICS.reduce((sum, topic) => sum + topic.subTopics.length, 0),
  estimatedHours: 10,
  difficultyLevel: 2, // 1-3 scale
  prerequisiteModules: 2
}; 